import React from "react";
import "./error-boundary.scss";
import { ErrorIndicator } from "../state-indicators";

export default class ErrorBoundary extends React.Component {
    state = {
        error: false
    };
    componentDidCatch() {
        this.setState({ error: true });
    }
    render() {
        const { error } = this.state;
        const { children, fillParent, errorCaptionKey } = this.props;

        return error ? <ErrorIndicator withCaption {...{ fillParent, errorCaptionKey }} /> : children;
    }
}
